module.exports = __webpack_public_path__ + "static/media/arrow.11da0daf.png";